const frequencies = [
    { name: 'Daily', value: 'daily', text: 'Daily' },
    { name: 'Every hour', value: 'immediately', text: 'Every hour' },
    { name: 'Only once', value: 'once', text: 'Only once' }
]
export default frequencies



// WEBPACK FOOTER //
// ./src/config/data/frequencies.js